// Utils pour les permissions de Training Reservations
// À adapter avec ton système d'authentification réel

export const hasPermission = (userRole, permission) => {
  const permissions = {
    'TL': ['create', 'edit_own', 'delete_own_pending'],
    'Material Manager': ['update_status', 'view_all', 'delete_pending_cancelled'],
    'SuperAdmin': ['delete_all', 'view_all', 'update_status']
  }
  
  return permissions[userRole]?.includes(permission) || false
}

export const canCreateReservation = (userRole) => {
  return hasPermission(userRole, 'create')
}

export const canEditReservation = (userRole, reservation, userId) => {
  return hasPermission(userRole, 'edit_own') && 
         reservation.user_id === userId && 
         reservation.status === 'pending'
}

export const canUpdateStatus = (userRole, reservation) => {
  return hasPermission(userRole, 'update_status') && reservation.status === 'pending'
}

export const canDeleteReservation = (userRole, reservation, userId) => {
  const isOwner = reservation.user_id === userId
  const isMaterialManager = userRole === 'Material Manager'
  const isSuperAdmin = userRole === 'SuperAdmin'
  
  if (isOwner && reservation.status === 'pending') return true
  if ((isMaterialManager || isSuperAdmin) && 
      ['pending', 'cancelled'].includes(reservation.status)) return true
  
  return false
}

// Simulation - à remplacer avec ton auth système
export const getCurrentUser = () => {
  return {
    id: localStorage.getItem('userId') || 1,
    role: localStorage.getItem('userRole') || 'TL',
    professionalInformation: {
      position: {
        code: localStorage.getItem('userRole') || 'TL'
      }
    }
  }
}
